import React from 'react';
import classNames from 'classnames';
import style from './MissingData.module.scss';

export enum MissingDataSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type MissingDataProps = {
  text: string;
  size?: MissingDataSizes;
  className?: string;
};

export const MissingData: React.FC<MissingDataProps> = ({
  text,
  className = '',
  size = MissingDataSizes.MEDIUM,
}) => {
  const imageSource = `../../assets/missing-data/missing-data-${size}.png`;
  const small = size === MissingDataSizes.SMALL;
  return (
    <div className={classNames(style['missingData'], small && style['small'], className)}>
      <img src={imageSource} alt="no-data" />
      <h6 className={classNames(style['text'], small && style['small'])}>{text}</h6>
    </div>
  );
};
